module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"10.5","cy":"10","fill":"#39b54a","r":"7.9"}}),_c('path',{attrs:{"d":"M13.6 8.8h-1.9V6.9c0-.4-.3-.8-.8-.8H10c-.4 0-.8.3-.8.8v1.9H7.3c-.4 0-.8.3-.8.8v.9c0 .4.3.8.8.8h1.9v1.9c0 .4.3.8.8.8h.9c.4 0 .8-.3.8-.8v-1.9h1.9c.4 0 .8-.3.8-.8v-1c-.1-.4-.4-.7-.8-.7z","fill":"#58595b"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/add_new.svg
// module id = 694
// module chunks = 2